import { render } from "./PrezidentPart.vue?vue&type=template&id=3fe6b096"
import script from "./PrezidentPart.vue?vue&type=script&lang=js"
export * from "./PrezidentPart.vue?vue&type=script&lang=js"

import "./PrezidentPart.vue?vue&type=style&index=0&id=3fe6b096&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__